import { render, staticRenderFns } from "./StudentHeadmenuLayout.vue?vue&type=template&id=4f3ea16f&scoped=true&lang=pug&"
import script from "./StudentHeadmenuLayout.vue?vue&type=script&lang=ts&"
export * from "./StudentHeadmenuLayout.vue?vue&type=script&lang=ts&"
import style0 from "./StudentHeadmenuLayout.vue?vue&type=style&index=0&id=4f3ea16f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3ea16f",
  null
  
)

export default component.exports